import React, { useContext, useState, useRef, useEffect } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap"
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { getDueDayRuleText, getGridLocalization, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from "../../../common/Helpers";
import SidePanelAddNew from "./SidePanelAddNew";
import SidePanelVinculateObligation from "./SidePanelVinculateObligation";
import { __MessageTypes, __TimeScale, enum_OBLIGATION_FORM_VIEW } from "../../../common/Dictionaries";
import MessageBox from "../../../components/Common/Message/MessageBox";
import MainAppContext from "../../../MainAppContext";
import * as XLSX from 'xlsx';
import MatrixToolbar from "../../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import { IconButton } from "@fluentui/react";
import { handlerFilter, removeGridLocalStorageFilters, setterActionFired, useFilterActionComponentData } from "../../../common/Helpers/JqxGridFilter";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import { useGetObligationCategorysMaintainer, useGetObligationsMaintainer } from "../../../hooks/services/sCO/useOfObligacion";
import { __OBJECT_STRUCTURE_Obligation } from "../../../common/ObjectStructures/sCO";
import { deleteObligacion } from "../../../services/sCO/obligation.service";

export default function Obligation(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const gridRef = useRef();

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    
    const [isPanelVinculateOpen, setIsPanelVinculateOpen] = useState(false);
    const [isPanelEditOpen, setIsPanelEditOpen] = useState(false);
    const [itemEdit, setItemEdit] = useState(null);

    const [listCategories, setListCategories] = useState(null);
    useGetObligationCategorysMaintainer(listCategories, setListCategories)

    const [listObligation, setListObligation] = useState(null);
    useGetObligationsMaintainer(listObligation, setListObligation, null);

    // JqxGrid no vuelve a pintar las celdas con createwidget/initwidget (columna acciones, columna subLegalEntities)
    // solo porque cambie la referencia de listObligation — hay que forzarlo con updatebounddata, mismo patrón que
    // usa Maintainers/sKPI/ContractModification/index.js (setterListContractModification).
    const setterListObligation = (list) => {
        setListObligation(list);
        if (gridRef.current) {
            gridRef.current.updatebounddata('cells');
        }
    };

    useFilterActionComponentData(gridRef, messageConfig, "Obligation");

    useEffect(() => {
        if (listObligation === null) {
            removeGridLocalStorageFilters("Obligation");
        }

    }, [listObligation]);

    const handlerDelete = async (itemId) => {
        if (itemId <= 0) {
            const newListContracts = listObligation.filter(x => x.id !== itemId);
            setterListObligation(newListContracts);
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
            setterActionFired("Obligation", 1);
        }
        else {
            await deleteObligacion(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newListContracts = listObligation.filter(x => x.id !== itemId);
                    setterListObligation(newListContracts);
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));  
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(serviceResponse.data.message));
                }
                setterActionFired("Obligation", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("Obligation", 1);
            });
        }
    };

    const handlerVinculate = async (itemId) => {
        // Se lee de listObligation (estado React crudo) y no de gridRef.current.props.source.records:
        // jqWidgets no preserva de forma confiable el array anidado subLegalEntities en sus records.
        const item = listObligation.find(x => x.id === itemId);
        setItemEdit(item);
        setIsPanelVinculateOpen(true);
    };

    const handlerEdit = async (itemId) => {
        const item = listObligation.find(x => x.id === itemId);
        setItemEdit(item);
        setIsPanelEditOpen(true);
    };

    const handlerAddNew = async () => {
        setItemEdit(__OBJECT_STRUCTURE_Obligation(0))
        setIsPanelEditOpen(true);
    };

    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    };

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        if (exportData) {
            const aux_list = listObligation.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                getColumns().forEach(column => {
                    if (column.exportable) {
                        if (column.exportValue) {
                            aux_row[column.dataField] = column.exportValue(row);
                        }
                        else if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: getColumns().filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        if (exportData) {
            XLSX.writeFile(workbook, 'Contract_ExportedData.xlsx');
        }
        else {
            XLSX.writeFile(workbook, 'Contract_UploadTemplate.xlsx');
        }
    };

    const getColumns = () => {
        const basicColumns = [
            { index: null, text: 'ID',                                        dataField: 'id',                          uploadMasive: false, exportable: false, width: '0px',   columntype: 'textbox', editable: false, hidden: true },
            { index: null, text: t('data-lang-lbl-actions'),                  dataField: 'acciones',                    uploadMasive: false, exportable: false, width: '100px', pinned: true,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            },                    
            { index: null, text: t('data-lang-lbl-category'),                 dataField: 'categoriaId',                 uploadMasive: false,  exportable: false, width: '0px',     editable: false, hidden: true },
            { index: 0,    text: t('data-lang-lbl-category'),                 dataField: 'categoriaNombre',             uploadMasive: false,  exportable: true,  width: '150px',   editable: false, pinned: true },
            { index: 1,    text: t('data-lang-lbl-name'),                     dataField: 'nombre',                      uploadMasive: false,  exportable: true,  width: '400px',   editable: false, pinned: true },
            { index: null, text: t('data-lang-lbl-sublegalentity'),           dataField: 'subLegalEntities',            uploadMasive: false, exportable: false, width: '500px', filterable: false, sortable: false, editable: false,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(subLegalEntitiesCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(subLegalEntitiesCellsRenderer(row), htmlElement); },
            },
            { index: 2,    text: t('data-lang-lbl-nemo'),                     dataField: 'nombreNemo',                  uploadMasive: false,  exportable: true,  width: '150px',   editable: false, pinned: true },
            { index: 3,    text: t('data-lang-lbl-description'),              dataField: 'descripcion',                 uploadMasive: false,  exportable: true,  width: '300px',   editable: false },                     
            { index: 4,    text: t('data-lang-lbl-periodic'),                 dataField: 'periodica',                   uploadMasive: false,  exportable: true,  width: '200px',   editable: false,
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')}</div>`; }
            },
            { index: 5,    text: t('data-lang-lbl-timescale'),                dataField: 'escalaTiempo',                uploadMasive: false,  exportable: true,  width: '200px',   editable: false,
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${!isNullUndefinedOrEmpty(value) ? t(__TimeScale[value].value) : t('no-data')}</div>`; }
            },
            { index: 6,    text: t('data-lang-lbl-alertperioddais'),          dataField: 'periodoAlerta',               uploadMasive: false,  exportable: true,  width: '200px',   editable: false },
            { index: 7,    text: t('data-lang-lbl-alertperiodmonths'),        dataField: 'periodicidadMeses',          uploadMasive: false,  exportable: true,  width: '200px',   editable: false },
            // «Día de vencimiento» sale de dos marcas (respertarUbicacionReferencia y ultimoDiaMes) y de la escala: se pinta y se exporta como texto.
            { index: 8,    text: t('data-lang-lbl-duedayrule-short'),         dataField: 'ultimoDiaMes',                uploadMasive: false,  exportable: true,  width: '250px',   editable: false, filterable: false,
                cellsrenderer: (row, column, value, defaulthtml, columnproperties, rowdata) => { return `<div style="margin-left: 8px; margin-top: 9px">${getDueDayRuleText(rowdata, t)}</div>`; },
                exportValue: (row) => getDueDayRuleText(row, t)
            },
            { index: 9,    text: t('data-lang-lbl-canachievebeforeduedate'),  dataField: 'cumplirAntesVencimiento',     uploadMasive: false,  exportable: true,  width: '200px',   editable: false,
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')}</div>`; }
            },
            { index: 10,   text: t('data-lang-lbl-postponeexpiration'),       dataField: 'postergarVencimiento',        uploadMasive: false,  exportable: true,  width: '200px',   editable: false,
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')}</div>`; }
            },
            { index: 11,   text: t('data-lang-lbl-finesnoncompliance'),       dataField: 'multaIncumplimiento',         uploadMasive: false,  exportable: true,  width: '200px',   editable: false,
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')}</div>`; }
            },
            { index: 12,   text: t('data-lang-lbl-clausulamulta'),            dataField: 'clausulaMulta',               uploadMasive: false,  exportable: true,  width: '250px',   editable: false },
            { index: 13,   text: t('data-lang-lbl-preventadnapproval'),       dataField: 'impedirAprobacionAdn',        uploadMasive: false,  exportable: true,  width: '200px',   editable: false,
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')}</div>`; }
            },
            { index: 14,   text: t('data-lang-lbl-requiredattacheddocument'), dataField: 'requiereDocumento',           uploadMasive: false,  exportable: true,  width: '200px',   editable: false,
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')}</div>`; }
            },     
            { index: 15,   text: t('data-lang-lbl-obligationreqvalidation'),  dataField: 'sujetaAValidacion',          uploadMasive: false,  exportable: true,  width: '200px',   editable: false,
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')}</div>`; }
            },
            { index: 16,   text: t('data-lang-lbl-responsibleroleachieve'),  dataField: 'rolClienteResponsableCumplimiento',  uploadMasive: false,  exportable: true,  width: '250px',   editable: false },
            { index: 17,   text: t('data-lang-lbl-responsiblerolevalidation'),dataField: 'rolClienteResponsableValidacion',    uploadMasive: false,  exportable: true,  width: '250px',   editable: false },
            // Visible para cualquier cliente (lo administran los Admin/sAdmin); solo la funcionalidad del
            // checklist en sí (que consume este flag) es exclusiva de AMSA.
            { index: 18,   text: 'Incluir en checklist EdP',                  dataField: 'incluirEnChecklistEdp',              uploadMasive: false,  exportable: true,  width: '200px',   editable: false,
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')}</div>`; }
            },
        ]

        return basicColumns;
    };

    const getDataFields = () => {
        const basicDataFields = [
            { name: 'id',                                type: 'number' },
            { name: 'categoriaId',                       type: 'number' },
            { name: 'categoriaNombre',                   type: 'string' },
            { name: 'nombre',                            type: 'string' },
            { name: 'nombreNemo',                        type: 'string' },
            { name: 'descripcion',                       type: 'string' },
            { name: 'periodica',                         type: 'bool'   },
            { name: 'periodoAlerta',                     type: 'number' },
            { name: 'periodicidadMeses',                 type: 'number' },
            { name: 'escalaTiempo',                      type: 'number' },
            { name: 'respertarUbicacionReferencia',      type: 'bool'   },
            { name: 'ultimoDiaMes',                      type: 'bool'   },
            { name: 'cumplirAntesVencimiento',           type: 'bool'   },
            { name: 'postergarVencimiento',              type: 'bool'   },
            { name: 'multaIncumplimiento',               type: 'bool'   },
            { name: 'clausulaMulta',                     type: 'string' },
            { name: 'impedirAprobacionAdn',              type: 'bool'   },
            { name: 'requiereDocumento',                 type: 'bool'   },
            { name: 'sujetaAValidacion',                 type: 'bool'   },
            { name: 'rolResponsableCumplimiento',        type: 'string' },
            { name: 'rolResponsableValidacion',          type: 'string' },
            { name: 'rolClienteResponsableCumplimiento', type: 'string' },
            { name: 'rolClienteResponsableValidacion',   type: 'string' },
            { name: 'incluirEnChecklistEdp',             type: 'bool'   },

        ]
    
        return basicDataFields
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'edit':
                handlerEdit(itemId)
                break;
            case 'delete':
                handlerDelete(itemId)
                break;
            case 'vinculate':
                handlerVinculate(itemId)
                break;
            default:
                break;
        }
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listObligation[rowIndex.boundindex].id;
        }
        return listObligation[rowIndex]?.id;
    };

    const subLegalEntitiesCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource);
        const item = listObligation.find(x => x.id === itemId);
        const codes = (item?.subLegalEntities || []).map(x => x.legalEntityCode);

        return  <div className="d-flex align-items-center h-100">
                {
                    codes.map(code => <span key={code} className="badge bg-secondary me-1 badge-grid-lg">{code}</span>)
                }
                </div>
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        return  <>
                {
                    profileHasAccess &&
                    <>
                        <IconButton iconProps={{ iconName: 'Link' }} title={t('data-lang-btn-attach')} ariaLabel={t('data-lang-lbl-attach')} onClick={() => fieldActionHandler(itemId, 'vinculate')} />
                        <IconButton iconProps={{ iconName: 'Edit' }} title={t('data-lang-btn-edit')} ariaLabel={t('data-lang-btn-edit')} onClick={() => fieldActionHandler(itemId, 'edit')} />
                        <IconButton iconProps={{ iconName: 'Delete' }} title={t('data-lang-btn-delete')} ariaLabel={t('data-lang-btn-delete')} onClick={() => fieldActionHandler(itemId, 'delete')} />
                    </>
                }
                </>
    };

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-obligations')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body style={{width: "100%"}} className="access-per-month-form-body h-100 overflow-hidden-deprecated">  
                    <div className="align-items-center h-100">
                        {
                            listObligation && listCategories &&
                            <>
                                <MatrixToolbar
                                    inputParam_HandleSaveData={null}
                                    inputParam_HandleUploadData={null}
                                    inputParam_HandleExportData={handlerExportData}
                                    inputParam_HandleAddRow={handlerAddNew}
                                    inputParam_Configuration={{
                                        buttons: {
                                            showExportData: true,
                                            showAddMasiveData: false,
                                            showAddData: true,
                                            showDownloadTemplate: false,
                                            showSaveAllData: false,
                                            saveAllDataText: '',
                                            groupedButtons: false
                                        },
                                        handlers: {
                                            handlerSave: null,
                                            handlerSaveAll: null,
                                            handlerDelete: profileHasAccess ? handlerDelete : null,
                                            handlerCancel: null,
                                        },
                                        auxiliarListCallbackOnAdd: null,
                                    }}
                                    inputParam_ExternalExportTemplates={[]}
                                    inputParam_CustomOpenPanel={null}
                                    showRequiredMessage={false}
                                />
                                <JqxGrid
                                    ref={gridRef}
                                    altrows={true}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    height={'500px'}
                                    editable={true}
                                    sortable={true}
                                    filterable={true}
                                    showfilterrow={true} 
                                    localization={getGridLocalization(t)}
                                    source={ new jqx.dataAdapter({
                                        localData: listObligation,
                                        dataType: 'array',
                                        dataFields: getDataFields(),
                                        id: 'id'
                                    })}
                                    columns={getColumns()}
                                    onFilter={(event) => handlerFilter(event, 'Obligation')}
                                />
                            </>
                        }
                    </div>
                    {
                        (isPanelEditOpen === true && !isNullUndefined(itemEdit) && !isNullUndefined(listObligation)) &&
                        <SidePanelAddNew
                            key={itemEdit.id}
                            inputParam_ItemToEdit={itemEdit}
                            inputParam_SetItemEdit={setItemEdit}
                            inputParam_IsPanelOpen={isPanelEditOpen}
                            inputParam_SetterIsPanelOpen={setIsPanelEditOpen}
                            inputParam_SetterLisObligations={setterListObligation}
                            inputParam_LisObligations={listObligation}
                            inputParam_FormView={itemEdit.id === 0 ? enum_OBLIGATION_FORM_VIEW.INSERT : enum_OBLIGATION_FORM_VIEW.EDIT}
                        />
                    } 
                    {
                        (isPanelVinculateOpen === true && !isNullUndefined(itemEdit)) &&
                        <SidePanelVinculateObligation
                            key={itemEdit.id}
                            inputParam_IsPanelOpen={isPanelVinculateOpen}
                            inputParam_EditMode={true}
                            inputParam_SetterIsPanelOpen={setIsPanelVinculateOpen}
                            inputParam_ObligationName={itemEdit.nombre}
                            inputParam_ObligationId={itemEdit.id}
                            inputParam_ObligationHasSubLegalEntity={(itemEdit.subLegalEntities || []).length > 0}
                        />
                    } 
                </Card.Body>
            </Card>   
        </div>
    ); 
}